import { observer } from 'mobx-react';
import { Outlet } from 'react-router-dom';
import { useContext, useEffect } from 'react';

import { appStore } from '../stores/app-store';
import { Spinner } from '../components/spinner';
import GameDesignerMenu from './game-designer-menu';
import { useVersionInfo } from '../contexts/version-info';
import { ToastProvider } from '../contexts/toast-context';
import { AuthRequired } from '../components/authentication';
import { GameDocumentContext } from '../contexts/game-document';
import { useUnsavedChangesGuard } from '../hooks/useUnsavedChangeGuard';

/**
 * The layout for game designer [portal] pages.
 * @returns
 */
const GameDesigner = observer(() => {
  const { setLoadedGameDocumentVersion } = useVersionInfo();
  const [gameState] = useContext(GameDocumentContext);

  useUnsavedChangesGuard(gameState.isDirty);

  useEffect(() => {
    const gameDocument = gameState?.gameDocument;
    const isValid = gameState?.isValid;

    if (!isValid || !gameState || !gameDocument) {
      return;
    }

    setLoadedGameDocumentVersion(gameDocument.version);

    // Cleanup/reset
    return () => {
      setLoadedGameDocumentVersion(null);
    };
  }, [
    setLoadedGameDocumentVersion,
    gameState?.gameDocument?.version,
    gameState?.isValid,
    gameState?.gameDocument
  ]);

  return (
    <AuthRequired>
      <ToastProvider>
        <div className={'layout layout--designer'}>
          {appStore.isLoading() && <Spinner />}
          <GameDesignerMenu />
          <div className={'app-main'}>
            <Outlet />
          </div>
        </div>
      </ToastProvider>
    </AuthRequired>
  );
});

export default GameDesigner;
